import React from 'react';
import DynamicSiteForm from './DynamicSiteForm';

const KosherSoupForm = ({ onClose }) => (
  <DynamicSiteForm formKey="kosher-soup" onClose={onClose} />
);

export default KosherSoupForm;
